let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aWhd2")).then(() => parcelRequire('7TuuZ'));